export default __webpack_public_path__ + "static/media/mac 2.3876b530.png";